import { Component, Input, Output, EventEmitter, OnChanges, inject } from '@angular/core';
import { VoiceProduct } from '@shared/models/voice-product.model';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import {
  VoiceProductUpdateAction,
  VoiceProductUpdateSponsorAction,
  VoiceProductUpdateSponsorTypeAction,
} from '@sales/states/customer-product/customer-product.actions';
import { IconNames } from '@shared/enums/icon-names';
import { VoiceAllowedChangeInfo } from '../../../models/offerings-response.model';
import { BindingType } from '@shared/models/subscription-offering.model';
import { Sponsor, SponsorType } from '@shared/models/sponsor.model';
import { SubscriptionHelperService } from '@app/sales/services/subscription-helper.service';
import { OrderBuilderStepComponent } from '../../subscription-stepper/order-builder-step/order-builder-step.component';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { IceBackButtonComponent } from '@app/shared/components/atoms/ice-back-button/ice-back-button.component';

@Component({
  selector: 'app-change-subscription',
  templateUrl: './change-subscription.component.html',
  styleUrls: ['./change-subscription.component.scss'],
  imports: [
    IceBackButtonComponent,
    SpinnerComponent,
    IceAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    OrderBuilderStepComponent,
  ],
})
export class ChangeSubscriptionComponent implements OnChanges {
  private store = inject(Store);

  IconNames = IconNames;

  @Input() product: VoiceProduct;
  @Output() finishedSelection = new EventEmitter();

  hasChangedServices: boolean = false;
  allowedOfferings: VoiceAllowedChangeInfo[] = [];

  form: FormGroup = new FormGroup({});
  displayIceJuniorCostControlWarning: boolean = false;

  ngOnChanges() {
    if (this.product.mobileProductId) {
      this.allowedOfferings = this.product.allowedSubscriptionOfferings;
    } else {
      if (!this.product.isLoadingSubscriptionOfferings) {
        // do not show handset binding when not connected to a mobile, since handset binding can only be sold together with a  mobile
        this.allowedOfferings = this.product.allowedSubscriptionOfferings?.filter(
          offering =>
            !(
              offering.subscriptionOffering.bindings?.length > 0 &&
              offering.subscriptionOffering.bindings.find(b => b.bindingType === BindingType.Handset)
            )
        );
      }
    }
  }

  onProductChange(event) {
    const productId = event.productId;
    const offering = event.offering;
    const changeInfo = event.changeInfo;

    this.displayIceJuniorCostControlWarning =
      SubscriptionHelperService.isProductIceJunior(this.product.subscription?.subscriptionType) &&
      SubscriptionHelperService.isProductIceJuniorPremium(offering?.subscriptionType);

    this.hasChangedServices =
      VoiceProduct.addedServices(this.product).length > 0 || VoiceProduct.removedServices(this.product).length > 0;

    this.store.dispatch(new VoiceProductUpdateAction(productId, offering, changeInfo));
  }

  onSponsorSelected({ productId, seller }) {
    const sponsor: Sponsor = {
      sponsorId: seller.userId,
      fullName: seller.fullName,
      email: seller.email,
      team: null,
      sponsorType: SponsorType.Ice,
    };

    this.store.dispatch(new VoiceProductUpdateSponsorAction(productId, sponsor));
  }

  onSponsorTypeSelected({ productId, sponsorType }) {
    this.store.dispatch(new VoiceProductUpdateSponsorTypeAction(productId, sponsorType));
  }
}
